<template>
  <div class="chinese-drug-advice">
    <h3>用药建议</h3>
    <ul class="drug-info">
      <li class="drug-item" v-for="item in prescriptionDetail.medicationList">
        {{ item.drugName }}
        <span v-if="item.usage">（{{ item.usage }}）</span>
        {{ item.perNum }}{{ item.perUnit }}
      </li>
    </ul>
    <div class="title">用法用量</div>
    <div class="item">
      共{{ prescriptionDetail.chineseMedicineDetail.usageNum }}剂，每日{{
        prescriptionDetail.chineseMedicineDetail.usageFrequency
      }}剂，每剂分{{ prescriptionDetail.chineseMedicineDetail.usagePerNum }}次使用
    </div>
    <div class="item">用药方式：{{ prescriptionDetail.chineseMedicineDetail.usageWay }}</div>
    <div class="item" v-if="prescriptionDetail.chineseMedicineDetail.usageTime">
      用药时间：{{ prescriptionDetail.chineseMedicineDetail.usageTime }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'chineseDrugAdvice',
  props: {
    prescriptionDetail: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.chinese-drug-advice {
  .drug-info {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 24px;

    .drug-item {
      display: flex;
      align-items: center;
      width: 33.3%;
      height: 40px;
      font-size: 14px;
      color: #595959;
    }
  }

  .title {
    margin-bottom: 13px;
    font-size: 14px;
    color: #242424;
  }

  .item {
    display: flex;
    align-items: center;
    height: 40px;
    font-size: 14px;
    color: #595959;
  }
}
</style>
